'use client';
import { useState } from 'react';
import FormErrorTips from '../comps/FormErrorTips';
import IconCheckbox from '../comps/IconCheckbox';

export default function FormCheckbox({ id, data, index, callback }: any) {
    const [showError, setShowError] = useState(false);
    const [selectList, setSelectList] = useState(data.selectList || []);
    const [active, setActive] = useState([]);
    const changeHandle = (item: any) => {
        let arr = [];
        if (active.includes(item)) {
            active.map((val: any) => {
                if (val !== item) {
                    arr.push(val);
                }
            });
        } else {
            arr = [...active, item];
        }
        setActive(arr);

        callback(data, index, arr); //回调到父级
        //判断是否显示错误提示
        if (data.isRequire && arr.length === 0) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    };

    return (
        <div className={`form-common-content form-common-radio form-common-checkbox ${showError ? ' form-common-show-error' : ''}`}>
            <div className="form-common-radio-title">{data.placeholder}</div>
            <div className="form-common-radio-list">
                {selectList.map((item: any, index: number) => {
                    return (
                        <div
                            className={`form-common-radio-item ${active.includes(item.value) ? ' form-common-radio-item-check' : ''}`}
                            key={index}
                            onClick={() => {
                                changeHandle(item.value);
                            }}
                        >
                            <span className="form-common-radio-input">
                                <IconCheckbox />
                            </span>
                            <span className="form-common-radio-label">{item.label}</span>
                        </div>
                    );
                })}
            </div>
            <FormErrorTips data={data} />
        </div>
    );
}
